import * as React from 'react';

import { cn } from '../base/utils';
import { useSkeletonMotion, type SkeletonAnimation } from '../skeleton/motion';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: 'muted' | 'accent';
  animate?: boolean;
  animation?: SkeletonAnimation;
}
export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { className, tone = 'muted', animate = true, animation, style, ...props },
  ref,
) {
  const motion = useSkeletonMotion(animation, animate, ref);
  return (
    <div
      {...props}
      ref={motion.ref}
      data-skeleton-animation={motion.mode}
      className={cn(
        motion.mode === 'pulse' && 'animate-pulse motion-reduce:animate-none',
        'rounded-md',
        tone === 'accent' ? 'bg-accent' : 'bg-muted',
        className,
      )}
      style={{ ...motion.style, ...style }}
    />
  );
});
